import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth/auth-guard.service';
import { AuthComponent } from './auth/auth.component';
import { noAuthGuard } from './auth/noauth-guard.service';
import { permissionGuard } from './auth/permission.guard';
import { HomeComponent } from './home/home.component';
import { SelectivePreloadingStrategy } from './shared/routing/selective-preloading.strategy';
import { PURCHASE_MODULE_PRELOAD_PERMISSIONS } from './shared/routing/preload-permissions';
//import { UsersComponent } from './mods/users/users.component';

//var uRoutes = usersRoutes;
// const dashboardRoutes: Routes = [
//   { path: 'dashboard', canActivate:[authGuard], component: TestComponent}
// ];

const appRoutes: Routes = [
    {
      path: 'public',
      data: { preloadPriority: 'never', preloadCost: 'small', preloadKey: '/public' },
      loadChildren: () =>
        import('./public/public.module').then((m) => m.PublicModule),
    },
    { 
      path: '',
      canActivate:[authGuard], 
      component: HomeComponent, 
            children: [
                {
                  path: 'mensajes',
                  data: { preloadPriority: 'intent', preloadCost: 'medium', preloadKey: '/mensajes' },
                  canActivate: [authGuard],
                  loadChildren: () =>
                    import('./shared/overlays/collaboration-routing.module').then(
                      (m) => m.CollaborationRoutingModule
                    ),
                },
                {
                  path: 'panel-operativo',
                  data: { preloadPriority: 'intent', preloadCost: 'medium', preloadKey: '/panel-operativo', preloadPermissions: ['panel:view'] },
                  loadChildren: () =>
                    import('./mods/dashboard-v2/dashboard-v2.module').then((m) => m.DashboardV2Module),
                },
                {
                  path: 'panel',
                  data: { preload: true, preloadPriority: 'immediate', preloadCost: 'medium', preloadKey: '/panel', preloadPermissions: ['panel:view'] },
                  loadChildren: () =>
                    import('./mods/dashboard/dashboard.module').then((m) => m.DashboardModule),
                },
                {
                  path: 'usuarios',
                  data: { preload: true, preloadPriority: 'idle', preloadCost: 'small', preloadKey: '/usuarios', preloadPermissions: ['users:view'] },
                  loadChildren: () =>
                    import('./mods/users/users.module').then((m) => m.UsersModule),
                },
                {
                  path: 'historial',
                  data: { preload: true, preloadPriority: 'idle', preloadCost: 'small', preloadKey: '/historial', preloadPermissions: ['history:view'] },
                  loadChildren: () =>
                    import('./mods/history/history.module').then((m) => m.HistoryModule),
                },
                {
                  path: 'arqueo',
                  data: { preloadPriority: 'never', preloadCost: 'medium', preloadKey: '/arqueo', preloadPermissions: ['arqueo:sales:view', 'arqueo:saf:view', 'arqueo:clients:view', 'arqueo:fondo:view'] },
                  loadChildren: () =>
                    import('./mods/arqueo/arqueo.module').then((m) => m.ArqueoModule),
                },
                {
                  path: 'agenda',
                  data: { preloadPriority: 'never', preloadCost: 'medium', preloadKey: '/agenda', preloadPermissions: ['agenda:view'] },
                  loadChildren: () =>
                    import('./mods/rtm/rtm.module').then((m) => m.RtmModule),
                },
                {
                  path: 'tags',
                  data: { preloadPriority: 'never', preloadCost: 'small', preloadKey: '/tags', preloadPermissions: ['tags:view'] },
                  loadChildren: () =>
                    import('./mods/tags/tags.module').then((m) => m.TagsModule),
                },
                {
                  path: 'precios',
                  data: { preload: true, preloadPriority: 'idle', preloadCost: 'small', preloadKey: '/precios', preloadPermissions: ['prices:view'] },
                  loadChildren: () =>
                    import('./mods/prices/prices.module').then((m) => m.PricesModule),
                },
                {
                  path: 'ventas',
                  data: { preloadPriority: 'intent', preloadCost: 'heavy', preloadKey: '/ventas', preloadPermissions: ['sales:view', 'sales:cierre_bol:view', 'sales:destino_bol:view'] },
                  loadChildren: () =>
                    import('./mods/sales/sales.module').then((m) => m.SalesModule),
                },
                {
                  path: 'inventario',
                  data: { preloadPriority: 'intent', preloadCost: 'heavy', preloadKey: '/inventario', preloadPermissions: ['inventory:view'] },
                  loadChildren: () =>
                    import('./mods/inventory/inventory.module').then((m) => m.InventoryModule),
                },
                {
                  path: 'inventario-consulta',
                  data: { preloadPriority: 'intent', preloadCost: 'heavy', preloadKey: '/inventario-consulta' },
                  loadChildren: () =>
                    import('./mods/inventario/inventario.module').then((m) => m.InventarioModule),
                },
                {
                  path: 'administracion',
                  data: { preloadPriority: 'never', preloadCost: 'medium', preloadKey: '/administracion', preloadPermissions: ['administracion:view'] },
                  loadChildren: () =>
                    import('./mods/administracion/administracion.module').then(
                      (m) => m.AdministracionModule
                    ),
                },
                {
                  path: 'visual',
                  data: { preloadPriority: 'intent', preloadCost: 'medium', preloadKey: '/visual', preloadPermissions: ['visual:view'] },
                  loadChildren: () =>
                    import('./mods/visual/visual.module').then((m) => m.VisualModule),
                },
                {
                  path: 'compras-v2',
                  canActivate: [authGuard, permissionGuard([...PURCHASE_MODULE_PRELOAD_PERMISSIONS])],
                  data: { preloadPriority: 'intent', preloadCost: 'heavy', preloadKey: '/compras-v2', preloadPermissions: PURCHASE_MODULE_PRELOAD_PERMISSIONS },
                  loadChildren: () =>
                    import('./mods/purchase-v2/purchase-v2.module').then((m) => m.PurchaseV2Module),
                },
                {
                  path: 'sincronizacion-salesbinder',
                  data: { preloadPriority: 'never', preloadCost: 'small', preloadKey: '/sincronizacion-salesbinder', preloadPermissions: ['salesbinder:manage'] },
                  loadChildren: () =>
                    import('./mods/salesbinder-import/salesbinder-import.module').then(
                      (m) => m.SalesBinderImportModule
                    ),
                }
            ]
    },
    { path: 'login', canActivate:[noAuthGuard], component: AuthComponent}
];
// for (let route of historyRoutes) {
//   appRoutes.push(route);
// }

@NgModule({
    declarations: [],
    imports: [ 
        RouterModule.forRoot(appRoutes, {
          preloadingStrategy: SelectivePreloadingStrategy,
        })
    ],
    exports: [RouterModule],
    providers: [],
})
export class AppRoutingModule {}
